import type { ReactNode } from 'react';
import { Button, type ButtonVariant } from './Button';

export interface ConfirmDialogProps {
  open: boolean;
  title: ReactNode;
  body: ReactNode;
  note?: ReactNode;
  confirmLabel: string;
  cancelLabel: string;
  variant?: ButtonVariant;
  busy?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/** Centred confirmation over a scrim. Two buttons, Cancel first. */
export function ConfirmDialog({
  open,
  title,
  body,
  note,
  confirmLabel,
  cancelLabel,
  variant = 'primary',
  busy,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  if (!open) return null;
  return (
    <div className="fw-scrim fw-scrim--center" onClick={onCancel}>
      <div
        role="dialog"
        aria-modal="true"
        className="fw-dialog"
        onClick={(e) => e.stopPropagation()}
      >
        <span className="fw-title">{title}</span>
        <span style={{ font: 'var(--type-body)', color: 'var(--text-muted)' }}>{body}</span>
        {note && (
          <span style={{ font: 'var(--type-body)', color: 'var(--text-muted)' }}>{note}</span>
        )}
        <div className="fw-dialog__actions">
          <Button variant="secondary" onClick={onCancel} disabled={busy}>
            {cancelLabel}
          </Button>
          <Button variant={variant} onClick={onConfirm} loading={busy}>
            {confirmLabel}
          </Button>
        </div>
      </div>
    </div>
  );
}
